var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-field"},[_c('v-list-tile',[_c('div',{staticClass:"body-2"},[_vm._v(_vm._s(_vm.label)+"：")]),_c('div',{staticClass:"body-1"},[_vm._v(_vm._s(_vm.value))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }